import React, { useEffect, useState } from 'react'
import * as am5 from "@amcharts/amcharts5";
import * as am5percent from "@amcharts/amcharts5/percent";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import useHttp from '../../../hook/use-http';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_bus';
import WaterMark from '../DashboardMain_Bus/WaterMark';

export default function PieChartAm({ gloablfilter }) {
  const { isLoading, error, sendReq: fetchData } = useHttp();

  const [net_consumption, setNetConsumption] = useState([]);
  const net_consumption_resp = (data) => {
    setNetConsumption(data);
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "energy_analysis_bus/consumption_fraction_and_factor", body: { filterdata: gloablfilter } }, net_consumption_resp)
  }, [gloablfilter])

  useEffect(() => {
    if (net_consumption.length > 0) {
      /* Imports */
      /* Chart code */
      // Create root element
      // https://www.amcharts.com/docs/v5/getting-started/#Root_element
      let root = am5.Root.new("chartdiv");

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      // Create chart
      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/
      let chart = root.container.children.push(am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        centerX: am5.percent(50),
        x: am5.percent(50),
        // y: am5.percent(65),
        // marginTop: 15,
        // marginBottom: 15,
        // marginLeft: 100,
        // marginRight: 100
        paddingTop: 20,
        // paddingBottom: 50
        paddingLeft: 15,
        paddingRight: 15
      }));

      // Create series
      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Series
      let series = chart.series.push(am5percent.PieSeries.new(root, {
        valueField: "value",
        categoryField: "category",
        tooltip: am5.Tooltip.new(root, {
          labelText: "[bold]{ti_field}[/]\n({value}%)",
        }),
        legendLabelText: "{category}",
        legendValueText: "",
        alignLabels: false,
      }));

      series.labels.template.setAll({
        fontSize: 12,
        // fill: am5.color(0x550000),
        text: "{value}" + "%",
        textType: "radial",
        centerX: am5.percent(15),
      });

      series.ticks.template.setAll({
        stroke: am5.color("#000000"),
        strokeWidth: 2,
        location: 0.8,
        // maxWidth: 1
        // opacity: 5,
      });

      series.get("colors").set("colors", [
        am5.color("#3e689f"),
        am5.color("#4778b8 "),
        am5.color("#608ac1 "),
        am5.color("#789ccb "),
        am5.color("#91aed4 "),
        am5.color("#c2d2e7 "),
        am5.color("#f3f6fa "),
      ]);
      series.slices.template.setAll({
        sepia: 1,
        brightness: 0.5,
        stroke: am5.color("#fff")
      });

      // series.set("fill", am5.color(0xff0000)); // set Series color to red
      // series2.set("fill", am5.color("#00ff00"));
      // var series = chart.series.push(
      //   am5percent.PieSeries.new(root, {
      //     name: "Series",
      //     valueField: "value",
      //     categoryField: "category",
      //     legendLabelText: "[{fill}]{category}[/]",
      //     legendLabelText: "{category}",
      //     legendValueText: "[bold {fill}][/]"
      //   })
      // );

      // Set data
      // https://www.amcharts.com/docs/v5/charts/percent-charts/pie-chart/#Setting_data
      series.data.setAll([
        {
          value: (net_consumption[0]["Traction_fr"] !== undefined) ? (net_consumption[0]["Traction_fr"].value).toFixed(2) : 0,
          category: "Traction Sys.",
          "ti_field": (net_consumption[0]["Traction System"] !== undefined) ? Number((net_consumption[0]["Traction System"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["HVAC_fr"] !== undefined) ? (net_consumption[0]["HVAC_fr"].value).toFixed(2) : 0,
          category: "HVAC",
          "ti_field": (net_consumption[0]["HVAC"] !== undefined) ? Number((net_consumption[0]["HVAC"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["aux1load_fr"] !== undefined) ? (net_consumption[0]["aux1load_fr"].value).toFixed(2) : 0,
          category: "AUX-1",
          "ti_field": (net_consumption[0]["Aux-1"] !== undefined) ? Number((net_consumption[0]["Aux-1"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["dcdcLoad_fr"] !== undefined) ? (net_consumption[0]["dcdcLoad_fr"].value).toFixed(2) : 0,
          category: "DC-DC",
          "ti_field": (net_consumption[0]["DC-DC"] !== undefined) ? Number((net_consumption[0]["DC-DC"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["aux2load_fr"] !== undefined) ? (net_consumption[0]["aux2load_fr"].value).toFixed(2) : 0,
          category: "AUX-2",
          "ti_field": (net_consumption[0]["Aux-2"] !== undefined) ? Number((net_consumption[0]["Aux-2"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["bcs1Load_fr"] !== undefined) ? (net_consumption[0]["bcs1Load_fr"].value).toFixed(2) : 0,
          category: "BCS-1",
          "ti_field": (net_consumption[0]["BCS-1"] !== undefined) ? Number((net_consumption[0]["BCS-1"].value).toFixed(2)) : 0
        },
        {
          value: (net_consumption[0]["bcs2Load_fr"] !== undefined) ? (net_consumption[0]["bcs2Load_fr"].value).toFixed(2) : 0,
          category: "BCS-2",
          "ti_field": (net_consumption[0]["BCS-2"] !== undefined) ? Number((net_consumption[0]["BCS-2"].value).toFixed(2)) : 0
        },
      ]);

      // Create legend
      // https://www.amcharts.com/docs/v5/charts/percent-charts/legend-percent-series/
      let legend = chart.children.push(am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        // centerY: am5.percent(0),
        y: am5.percent(76),
        marginTop: 15,
        marginBottom: 15,
        // paddingLeft: 10,
        // paddingRight: 10,
        // layout: root.verticalLayout
        layout: am5.GridLayout.new(root, {
          maxColumns: 4,
          fixedWidthGrid: false
        })
      }));
      legend.valueLabels.template.set("forceHidden", true);
      legend.data.setAll(series.dataItems);

      // Play initial series animation
      // https://www.amcharts.com/docs/v5/concepts/animations/#Animation_of_series
      series.appear(1000, 100);
      chart.appear(1000, 100);
      root._logo.dispose();
      return () => root.dispose();
    }

  }, [net_consumption])

  return (
    <>
      <WaterMark />
      <div id='chartdiv' className='energyChartboxNew_Bus' style={{ width: "auto", height: "100%" }}>
        <div className="v-title energyTitleChart_Bus pt-2 pb-2 pl-2 text-center">
          <b className=''>Consumption Fraction</b>
        </div>
      </div>
    </>
  )

}

